import {
    SET_CANDIDATURES_LOADING,
    SET_CANDIDATURES_ERROR,

    FETCH_CANDIDATURES_SUCCESS,
    FETCH_CANDIDATURES_FAIL,

    FETCH_CANDIDATURE_SUCCESS,
    FETCH_CANDIDATURE_FAIL,

    FETCH_CANDIDATURES_BY_DEMANDE_SUCCESS,
    FETCH_CANDIDATURES_BY_DEMANDE_FAIL,

    FETCH_CANDIDATURES_BY_CANDIDAT_SUCCESS,
    FETCH_CANDIDATURES_BY_CANDIDAT_FAIL,

    CREATE_CANDIDATURE_FAIL,
    UPDATE_CANDIDATURE_FAIL,

    ANNULER_CANDIDATURE_FAIL,
    REJETER_CANDIDATURE_FAIL,
    VALIDER_CANDIDATURE_FAIL,

    DELETE_CANDIDATURE_SUCCESS,
    DELETE_CANDIDATURE_FAIL,
} from "../actions/candidaturesActions";

const initialState = {
    loading: false,
    error: null,
    candidatures: [],
    candidature: null,
};

export default function candidaturesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CANDIDATURES_LOADING:
            return { ...state, loading: action.payload };

        case SET_CANDIDATURES_ERROR:
            return { ...state, error: action.payload };

        case FETCH_CANDIDATURES_SUCCESS:
            return {
                ...state,
                candidatures: action.payload || [],
                error: null,
            };

        case FETCH_CANDIDATURE_SUCCESS:
            return {
                ...state,
                candidature: action.payload || null,
                error: null,
            };

        case FETCH_CANDIDATURES_BY_DEMANDE_SUCCESS:
            return {
                ...state,
                candidatures: action.payload || [],
                error: null,
            };

        case FETCH_CANDIDATURES_BY_CANDIDAT_SUCCESS:
            return {
                ...state,
                candidatures: action.payload || [],
                error: null,
            };

        case FETCH_CANDIDATURES_FAIL:
        case FETCH_CANDIDATURE_FAIL:
        case FETCH_CANDIDATURES_BY_DEMANDE_FAIL:
        case FETCH_CANDIDATURES_BY_CANDIDAT_FAIL:
        case CREATE_CANDIDATURE_FAIL:
        case UPDATE_CANDIDATURE_FAIL:
        case ANNULER_CANDIDATURE_FAIL:
        case REJETER_CANDIDATURE_FAIL:
        case VALIDER_CANDIDATURE_FAIL:
        case DELETE_CANDIDATURE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_CANDIDATURE_SUCCESS:
            return {
                ...state,
                candidatures: state.candidatures.filter((item) => item.id !== action.payload),
                error: null,
            };

        default:
            return state;
    }
}